import React, { useRef, useEffect } from "react";

const Fusion360Images = ({ onLoadComplete, isLoading, setIsLoading, fileUrl }) => {
  const ref = useRef(null);

  useEffect(() => {
    const myWebAppElement = document.getElementById("myWebApp");

    if (!myWebAppElement) {
      console.error("myWebApp element not found");
      return;
    }

    const startTime = Date.now();
    const minDisplayTime = 4000; // 4 seconds minimum

    setIsLoading(true);

    // Fallback timeout in case the callback doesn't fire
    const fallbackTimeout = setTimeout(() => {
      console.log("Fallback timeout triggered - showing Metareal screen");
      setIsLoading(false);
    }, minDisplayTime);

    let player = window.MetarealPlayerSDK.create("myWebApp");
    player.load(fileUrl, () => {
      console.log("Metareal player loaded successfully");
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minDisplayTime - elapsedTime);

      clearTimeout(fallbackTimeout); // Clear fallback since callback fired

      setTimeout(() => {
        console.log("Setting isLoading to false");
        setIsLoading(false);
        if (onLoadComplete) {
          onLoadComplete();
        }
      }, remainingTime);
    });

    // Cleanup function
    return () => {
      clearTimeout(fallbackTimeout);
      if (myWebAppElement && myWebAppElement.firstChild) {
        myWebAppElement.removeChild(myWebAppElement.firstChild);
      }
    };
  }, [setIsLoading, onLoadComplete, fileUrl]);

  return (
    <div className="w-100 h-100 d-flex flex-column align-items-center" style={{ overflow: "hidden" }}>
      <div
        className="webapp"
        id="myWebApp"
        ref={ref}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default Fusion360Images;
